import { Button as AntButton, Modal } from 'antd';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getSurveyResult } from '../../../../../../api/placeTest.api';
import useAxios from '../../../../../../hooks/useAxios';
import { IGetSurveyResult } from '../../../../../../models/placeTest.model';
import ErrorResponse from '../../../../../ErrorResponse';
import Loader from '../../../../../Loader';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  platRequireCode: number;
}

const ShowSurveyModal: FC<IProps> = ({
  visible,
  setVisible,
  platRequireCode,
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetSurveyResult>();

  useEffect(() => {
    if (platRequireCode) {
      execute(getSurveyResult(platRequireCode));
    }
  }, []);

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <Modal
        title={t('entrance.schedule.button8')}
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setVisible(false)}
            >
              {t('common.button.close')}
            </AntButton>
          </div>
        ]}
      >
        <div className='comm-table__area rowType edit mt-0'>
          <table>
            <tbody>
              <tr>
                <th>{t('entrance.schedule.column39')}</th>
                <th>{t('entrance.schedule.column40')}</th>
              </tr>
              {res?.data.map(item => (
                <tr>
                  <td>{item.surveyQus}</td>
                  <td>{item.surveyAns}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal>
    </>
  );
}

export default ShowSurveyModal;
